import React from "react";
import { useState, useEffect } from "react";
import {
  KendoDropdown,
  disableKendoDropdown,
} from "../../Kendo/kendo_dropdown";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import RevenueMatrix from "./Revenue/RevenueMatrix";
import { useDispatch, useSelector } from "react-redux";
import {
  changeType,
  changeYear,
  getRevenuData,
  getMatrixDropValue,
} from "./Revenue/RevenueSlice";
import { GetExecutionData } from "./Execution/Executionslice";
import { Loader } from "../../Util/common";
import {
  getCountOnLeadBarData,
  getCountOnLeadCardsData,
  getCountOnLeadData,
  changechartflag,
} from "./CountsOnLead/CountonLeadSlice";
import { getRingCentralCardData } from "./RingCentral/RingCentralSlice";

import {
  getReviewCardData,
  getGeneralReviewBarData,
  getReviewBarData,
  getReviewData,
} from "./CustomerStatisfation/CustomerStatisficationSlice";
import { GetSalesData } from "./Sales/SalesSlice";
import { KendoLoader } from "../../Kendo/kendo_loader";
const CommonDropdown = ({
  CountsOnLead,
  setGeoShow,
  RingCentral,
  csStatisfaction,
  sales,
  RevenueModule,
  Execution,
}) => {
  const currentDate = new Date();
  const formattedDate =
    currentDate.getDate().toString().padStart(2, "0") +
    "-" +
    (currentDate.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    currentDate.getFullYear();
  const currentYear = currentDate.getFullYear().toString();

  const [calendarValue, setCalendarValue] = useState(1);
  const [MatrixValue, setMatrixvalue] = useState(0);
  const [MetrixText, setMetrixText] = useState("");
  const [revenueWeek, setrevenueWeek] = useState([]);
  const [isRevenueMonth, setIsRevenueMonth] = useState(true);
  const [isRevenueQuarter, setIsRevenueQuarter] = useState(false);
  const [isRevenueWeek, setIsRevenueWeek] = useState(false);
  const [isRevenueDay, setIsRevenueDay] = useState(false);
  const [isBallroom, setBallroom] = useState(false);
  const [isCulture, setCulture] = useState(false);
  const [Geo, setGeo] = useState(false);
  const [ReferralType, setReferralType] = useState(false);
  const [Salesperson, setSalesperson] = useState(false);
  const [BusinessArea, setBusinessArea] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [selectedStatus, setselectedStatus] = useState("");

  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const [data, setData] = useState([]);
  const [CountsOnLeadsMetrics, setCountsOnLeadsMetrics] = useState("0");
  const dispatch = useDispatch();
  const [CountsOnLeadsMetricFlag, setCountsOnLeadsMetricFlag] = useState(false);
  const [typeFlag, settypeFlag] = useState(false);
  const [selectedMatrix, setselectedMatrix] = useState("");
  const [revenueYear, setRevenueYear] = useState([]);
  const [ischanged, setischanged] = useState(false);

  const { revenueDataLoaded, MatrixDropVal, MatrixDropLoaded, metrics } =
    useSelector((state) => state.revenue);
  const { cardDataLoaded, chartflag } = useSelector(
    (state) => state.countonLead
  );
  const { RingCentralcardDataLoaded } = useSelector(
    (state) => state.ringcentral
  );

  const [filterValue, setFilterValue] = useState("0");

  const getDropdownvalue = () => {
    dispatch(getMatrixDropValue());
  };

  const getWeeks = () => {
    const weeksInYear = 52;
    const newWeeks = Array.from({ length: weeksInYear }, (_, index) => ({
      id: index + 1,
      text: "Week " + (index + 1),
    }));
    newWeeks.unshift({ id: 0, text: "All" });
    setrevenueWeek([...newWeeks]);
  };

  useEffect(() => {
    getWeeks();
  }, []);

  useEffect(() => {
    if (
      MatrixDropVal &&
      MatrixDropVal != undefined &&
      MatrixDropVal.Table0Records != undefined &&
      MatrixDropVal.Table1Records != undefined &&
      MatrixDropVal.Table2Records != undefined &&
      MatrixDropVal.Table3Records != undefined &&
      MatrixDropVal.Table4Records != undefined
    ) {
      if (isBallroom) {
        setData(MatrixDropVal?.Table0Records);
      }
      if (isCulture) {
        setData(MatrixDropVal?.Table1Records);
      }
      if (ReferralType) {
        setData(MatrixDropVal?.Table2Records);
      }
      if (Salesperson) {
        setData(MatrixDropVal?.Table3Records);
      }
      if (BusinessArea) {
        setData(MatrixDropVal?.Table4Records);
      }
    }
  }, [MatrixDropVal]);

  useEffect(() => {
    if (selectedStatus != "") {
      const typeValue =
        calendarValue == 1
          ? "Month"
          : calendarValue == 2
          ? "Quarterly"
          : calendarValue == 3
          ? "Week"
          : calendarValue == 4
          ? "Day"
          : "Year";

      dispatch(
        getCountOnLeadBarData({
          type: typeValue,
          years: selectedYear,
          filter:
            calendarValue == 1
              ? selectedMonth
              : calendarValue == 2
              ? selectedQuarter
              : calendarValue == 3
              ? selectedWeek
              : calendarValue == 4
              ? selectedDate
              : selectedYear,
          metrics: selectedStatus,
          value: "",
        })
      );

      dispatch(
        getCountOnLeadCardsData({
          type: typeValue,
          years: selectedYear,
          filter:
            calendarValue == 1
              ? selectedMonth
              : calendarValue == 2
              ? selectedQuarter
              : calendarValue == 3
              ? selectedWeek
              : calendarValue == 4
              ? selectedDate
              : selectedYear,
          metrics: selectedStatus,
          value: "",
        })
      );

      dispatch(
        changeType({
          type: typeValue,
          filter:
            calendarValue == 1
              ? selectedMonth
              : calendarValue == 2
              ? selectedQuarter
              : calendarValue == 3
              ? selectedWeek
              : calendarValue == 4
              ? selectedDate
              : selectedYear,
          metrices: selectedStatus === "" ? metrics.metrices : selectedStatus,
          metricesValue:
            selectedStatus === "" ? metrics.metricesValue : selectedStatus,
        })
      );
    }
  }, [selectedStatus]);

  const revenueCalendar = [
    { id: 1, value: "Monthly" },
    { id: 2, value: "Quarterly" },
    { id: 3, value: "Weekly" },
    { id: 4, value: "Daily" },
  ];

  const revenueCalendarOnChange = (e) => {
    setischanged(true);
    const convertToInteger = parseInt(e);
    setCalendarValue(convertToInteger);
    switch (convertToInteger) {
      case 0:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);
        break;
      case 1:
        setIsRevenueMonth(true);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);
        setSelectedQuarter(["0"]);
        setSelectedWeek(0);
        setSelectedDate(formattedDate);

        break;
      case 2:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(true);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);
        setSelectedMonth(["0"]);
        setSelectedWeek(0);
        setSelectedDate(formattedDate);

        break;
      case 3:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(true);
        setIsRevenueDay(false);
        setSelectedMonth(["0"]);
        setSelectedQuarter(["0"]);
        setSelectedDate(formattedDate);

        break;
      case 4:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(true);
        setSelectedMonth(["0"]);
        setSelectedQuarter(["0"]);
        setSelectedWeek(0);

        break;

      default:
        break;
    }

    const setFilter =
      convertToInteger === 0
        ? "0"
        : convertToInteger === 1
        ? selectedMonth
        : convertToInteger === 2
        ? selectedQuarter
        : convertToInteger === 3
        ? selectedWeek
        : convertToInteger === 4
        ? selectedDate
        : "";

    if (CountsOnLead) {
      dispatch(
        getCountOnLeadBarData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedStatus,
          value: "",
        })
      );
      dispatch(
        getCountOnLeadCardsData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedStatus,
          value: "",
        })
      );
    } else if (RingCentral) {
      dispatch(
        getRingCentralCardData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: "",
          value: "",
        })
      );
    } else if (csStatisfaction) {
      dispatch(
        getReviewData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedMatrix,
          value: metrics.metricesValue,
        })
      );
    } else if (sales) {
      dispatch(
        GetSalesData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedMatrix,
          value: metrics.metricesValue,
        })
      );
    } else if (RevenueModule) {
      dispatch(
        getRevenuData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedMatrix,
          value: metrics.metricesValue,
        })
      );
    } else if (Execution) {
      dispatch(
        GetExecutionData({
          type:
            convertToInteger === 1
              ? "Month"
              : convertToInteger === 2
              ? "Quarterly"
              : convertToInteger === 3
              ? "Week"
              : convertToInteger === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter: setFilter,
          metrics: selectedMatrix,
          value: metrics.metricesValue,
        })
      );
    }

    dispatch(
      changeType({
        type:
          convertToInteger == 1
            ? "Month"
            : convertToInteger == 2
            ? "Quarterly"
            : convertToInteger == 3
            ? "Week"
            : convertToInteger == 4
            ? "Day"
            : "Year",
        filter: setFilter,
        metrices: selectedStatus === "" ? metrics.metrices : selectedStatus,
        metricesValue:
          selectedStatus === "" ? metrics.metricesValue : selectedStatus,
      })
    );
  };

  const LeadsMetricsOnChange = (e) => {
    setischanged(true);
    let numString = e;
    let numArray = numString.split(",");
    if (numArray[0] == "0" || !numArray.includes("0")) {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num !== "0") : numArray;
    } else {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num == "0") : numArray;
    } 

    if (numArray.length > 1) {
      setCountsOnLeadsMetricFlag(true);
    } else {
      setCountsOnLeadsMetricFlag(false);
    }
    let status = "";
    if (numArray.length > 0) {
      numArray.forEach((element) => {
        const numericChange = parseInt(element);
        status += LeadStatus[numericChange] + ",";
      });
      setselectedStatus(status);
    }

    e = numArray.join(",");
    let spliType = e.split(",");
    if (spliType == "") {
      setCountsOnLeadsMetrics("0");
      status =
        "TC Sent,CC Sent,Guaranteed,R Mail sent - Automated,R Mail sent - Manual,R email sent Tour Not Booked,Tour Booked,Tour - Done,Tour Booked but No Show,Closed,Date N/A,Spoke to Client - Tour N/B";
      setselectedStatus(status);
    } else {
      setCountsOnLeadsMetrics(spliType);
    }
  };

  const months = [
    { id: "0", text: "All Month" },
    { id: "01", text: "January" },
    { id: "02", text: "February" },
    { id: "03", text: "March" },
    { id: "04", text: "April" },
    { id: "05", text: "May" },
    { id: "06", text: "June" },
    { id: "07", text: "July" },
    { id: "08", text: "August" },
    { id: "09", text: "September" },
    { id: "10", text: "October" },
    { id: "11", text: "November" },
    { id: "12", text: "December" },
  ];
  const weeks = [
    { id: "0", text: "All Week" },
    { id: "1", text: "Week 1" },
    { id: "2", text: "Week 2" },
    { id: "3", text: "Week 3" },
    { id: "4", text: "Week 4" },
    { id: "5", text: "Week 5" },
    { id: "6", text: "Week 6" },
    { id: "7", text: "Week 7" },
    { id: "8", text: "Week 8" },
    { id: "9", text: "Week 9" },
    { id: "10", text: "Week 10" },
    { id: "11", text: "Week 11" },
    { id: "12", text: "Week 12" },
    { id: "13", text: "Week 13" },
    { id: "14", text: "Week 14" },
    { id: "15", text: "Week 15" },
    { id: "16", text: "Week 16" },
    { id: "17", text: "Week 17" },
    { id: "18", text: "Week 18" },
    { id: "19", text: "Week 19" },
    { id: "20", text: "Week 20" },
    { id: "21", text: "Week 21" },
    { id: "22", text: "Week 22" },
    { id: "23", text: "Week 23" },
    { id: "24", text: "Week 24" },
    { id: "25", text: "Week 25" },
    { id: "26", text: "Week 26" },
    { id: "27", text: "Week 27" },
    { id: "28", text: "Week 28" },
    { id: "29", text: "Week 29" },
    { id: "30", text: "Week 30" },
    { id: "31", text: "Week 31" },
    { id: "32", text: "Week 32" },
    { id: "33", text: "Week 33" },
    { id: "34", text: "Week 34" },
    { id: "35", text: "Week 35" },
    { id: "36", text: "Week 36" },
    { id: "37", text: "Week 37" },
    { id: "38", text: "Week 38" },
    { id: "39", text: "Week 39" },
    { id: "40", text: "Week 40" },
    { id: "41", text: "Week 41" },
    { id: "42", text: "Week 42" },
    { id: "43", text: "Week 43" },
    { id: "44", text: "Week 44" },
    { id: "45", text: "Week 45" },
    { id: "46", text: "Week 46" },
    { id: "47", text: "Week 47" },
    { id: "48", text: "Week 48" },
    { id: "49", text: "Week 49" },
    { id: "50", text: "Week 50" },
    { id: "51", text: "Week 51" },
    { id: "52", text: "Week 52" },
    { id: "53", text: "Week 53" },
  ];
  const Quarterly = [
    { id: "0", text: "All Quarterly" },
    { id: "1", text: "1st Quarterly" },
    { id: "2", text: "2nd Quarterly" },
    { id: "3", text: "3rd Quarterly" },
    { id: "4", text: "4th Quarterly" },
  ];
  const Matrix = [
    { matrixId: 0, matrixValue: "All Matrix" },
    { matrixId: 1, matrixValue: "Ballrooms" },
    { matrixId: 2, matrixValue: "Culture" },
    { matrixId: 3, matrixValue: "Geo" },
    { matrixId: 4, matrixValue: "Referral Type" },
    { matrixId: 5, matrixValue: "Sales Person / Event Specailist" },
    { matrixId: 6, matrixValue: "Business Area" },
  ];

  const CountsOnLeadsFilters = [
    { id: "0", value: "All Status" },
    { id: "1", value: "TC/CC Sent" },
    { id: "2", value: "Guaranteed" },
    {
      id: "3",
      value: "R Mail sent",
    },
    { id: "4", value: "Tour Booked" },
    { id: "5", value: "Tour - Done" },
    { id: "6", value: "No Show" },
    { id: "7", value: "Closed" },
    { id: "8", value: "Date N/A" },
    { id: "9", value: "Spoke to Client - Tour N/B" },
  ];

  const LeadStatus = [
    "TC Sent,CC Sent,Guaranteed,R Mail sent - Automated,R Mail sent - Manual,R email sent Tour Not Booked,Tour Booked,Tour - Done,Tour Booked but No Show,Closed,Date N/A,Spoke to Client - Tour N/B",
    "TC Sent",
    "Guaranteed",
    "R Mail sent - Automated,R Mail sent - Manual,R email sent Tour Not Booked",
    "Tour Booked",
    "Tour - Done",
    "Tour Booked but No Show",
    "Closed",
    "Date N/A",
    "Spoke to Client - Tour N/B",
  ];

  const matrixOnChange = (e) => {
    setischanged(true);
    let Indexparsingvalue = parseInt(e);
    if (Indexparsingvalue == 3) {
      setData([]);
      dispatch(changeType({ metricesValue: "" }));
    }

    setMatrixvalue(Indexparsingvalue);

    const selected =
      Indexparsingvalue == 1
        ? "FunctionLocation"
        : Indexparsingvalue == 2
        ? "Culture"
        : Indexparsingvalue == 3
        ? "Geo"
        : Indexparsingvalue == 4
        ? "ReferralType"
        : Indexparsingvalue == 5
        ? "Salesperson"
        : Indexparsingvalue == 6
        ? "EventType"
        : "";
    setMetrixText(selected);
    setselectedMatrix(selected);

    switch (Indexparsingvalue) {
      case 0:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setGeoShow(false);
        setSalesperson(false);
        setBusinessArea(false);
        break;
      case 1:
        setBallroom(true);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setGeoShow(false);
        setSalesperson(false);
        setBusinessArea(false);

        break;
      case 2:
        setBallroom(false);
        setCulture(true);
        setGeo(false);
        setReferralType(false);
        setGeoShow(false);
        setSalesperson(false);
        setBusinessArea(false);

        break;
      case 3:
        setBallroom(false);
        setCulture(false);
        setGeo(true);
        setReferralType(false);
        setGeoShow(true);
        setSalesperson(false);
        setBusinessArea(false);

        break;
      case 4:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(true);
        setGeoShow(false);
        setSalesperson(false);
        setBusinessArea(false);

        break;
      case 5:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setGeoShow(false);
        setBusinessArea(false);
        setSalesperson(true);
        break;
      case 6:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setGeoShow(false);
        setSalesperson(false);
        setBusinessArea(true);
        break;
      default:
        break;
    }
    if (sales) {
      dispatch(
        GetSalesData({
          type:
            calendarValue === 1
              ? "Month"
              : calendarValue === 2
              ? "Quarterly"
              : calendarValue === 3
              ? "Week"
              : calendarValue === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter:
            calendarValue === 1
              ? selectedMonth
              : calendarValue === 2
              ? selectedQuarter
              : calendarValue === 3
              ? selectedWeek
              : calendarValue === 4
              ? selectedDate
              : "",
          metrics: selected,
          value: "",
        })
      );
    }

    if (RevenueModule) {
      dispatch(
        getRevenuData({
          type:
            calendarValue === 1
              ? "Month"
              : calendarValue === 2
              ? "Quarterly"
              : calendarValue === 3
              ? "Week"
              : calendarValue === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter:
            calendarValue === 0
              ? "0"
              : calendarValue === 1
              ? selectedMonth
              : calendarValue === 2
              ? selectedQuarter
              : calendarValue === 3
              ? selectedWeek
              : selectedDate,
          metrics: selected,
          value: "",
        })
      );
    }

    if (Execution) {
      dispatch(
        GetExecutionData({
          type:
            calendarValue === 1
              ? "Month"
              : calendarValue === 2
              ? "Quarterly"
              : calendarValue === 3
              ? "Week"
              : calendarValue === 4
              ? "Day"
              : "Year",
          years: selectedYear,
          filter:
            calendarValue === 0
              ? "0"
              : calendarValue === 1
              ? selectedMonth
              : calendarValue === 2
              ? selectedQuarter
              : calendarValue === 3
              ? selectedWeek
              : selectedDate,
          metrics: selected,
          value: "",
        })
      );
    }

    if (csStatisfaction) {
      if (Indexparsingvalue == 3) {
        dispatch(
          getReviewData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: "Geo",
            value: "",
          })
        );
      } else {
        dispatch(
          getReviewData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: selected,
            value: "",
          })
        );
      }
    }

    dispatch(
      changeType({
        type:
          calendarValue === 1
            ? "Month"
            : calendarValue === 2
            ? "Quarterly"
            : calendarValue === 3
            ? "Week"
            : calendarValue === 4
            ? "Day"
            : "Year",
        filter:
          calendarValue === 0
            ? "0"
            : calendarValue === 1
            ? selectedMonth
            : calendarValue === 2
            ? selectedQuarter
            : calendarValue === 3
            ? selectedWeek
            : selectedDate,
        metrices:
          Indexparsingvalue == 1
            ? "FunctionLocation"
            : Indexparsingvalue == 2
            ? "Culture"
            : Indexparsingvalue == 3
            ? "Geo"
            : Indexparsingvalue == 4
            ? "ReferralType"
            : Indexparsingvalue == 5
            ? "Salesperson"
            : Indexparsingvalue == 6
            ? "EventType"
            : "",
        metricesValue: "",
      })
    );

    getDropdownvalue();
  };

  const revenueYearOnChage = (e) => {
    setischanged(true);
    const splityear = e.split(",");
    setSelectedYear(splityear);
  };

  useEffect(() => {
    if (ischanged) {
      if (CountsOnLead) {
        dispatch(
          getCountOnLeadBarData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: selectedStatus,
            value: selectedStatus,
          })
        );

        dispatch(
          getCountOnLeadCardsData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: selectedStatus,
            value: "",
          })
        );
      } else if (RingCentral) {
        dispatch(
          getRingCentralCardData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: "",
            value: "",
          })
        );
      } else if (csStatisfaction) {
        dispatch(
          getReviewData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: selectedMatrix,
            value: metrics.metricesValue,
          })
        );
      } else if (sales) {
        dispatch(
          GetSalesData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics: selectedMatrix,
            value: metrics.metricesValue,
          })
        );
      } else if (RevenueModule) {
        dispatch(
          getRevenuData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics:
              MatrixValue === 1
                ? "FunctionLocation"
                : MatrixValue === 2
                ? "Culture"
                : MatrixValue === 3
                ? "Geo"
                : MatrixValue === 4
                ? "ReferralType"
                : MatrixValue === 5
                ? "Salesperson"
                : MatrixValue == 6
                ? "EventType"
                : "",
            value: metrics.metricesValue,
          })
        );
      } else if (Execution) {
        dispatch(
          GetExecutionData({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            years: selectedYear,
            filter:
              calendarValue === 0
                ? "0"
                : calendarValue === 1
                ? selectedMonth
                : calendarValue === 2
                ? selectedQuarter
                : calendarValue === 3
                ? selectedWeek
                : selectedDate,
            metrics:
              MatrixValue === 1
                ? "FunctionLocation"
                : MatrixValue === 2
                ? "Culture"
                : MatrixValue === 3
                ? "Geo"
                : MatrixValue === 4
                ? "ReferralType"
                : MatrixValue === 5
                ? "Salesperson"
                : MatrixValue == 6
                ? "EventType"
                : "",
            value: metrics.metricesValue,
          })
        );
      }
      dispatch(
        changeType({
          type:
            calendarValue === 1
              ? "Month"
              : calendarValue === 2
              ? "Quarterly"
              : calendarValue === 3
              ? "Week"
              : calendarValue === 4
              ? "Day"
              : "Year",
          filter:
            calendarValue === 0
              ? "0"
              : calendarValue === 1
              ? selectedMonth
              : calendarValue === 2
              ? selectedQuarter
              : calendarValue === 3
              ? selectedWeek
              : selectedDate,
          metrices: selectedMatrix,
          metricesValue: metrics.metricesValue,
        })
      );
      dispatch(changeYear(selectedYear));
    }
  }, [selectedYear]);

  const typeOnChange = (e, type) => {
    setischanged(true);
    let numString = e;
    let numArray = numString.split(",");
    if (numArray[0] == "0" || !numArray.includes("0")) {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num !== "0") : numArray;
    } else {
      numArray =
        numArray.length > 1 ? numArray.filter((num) => num == "0") : numArray;
    }

    e = numArray.join(",");
    if (e == "") {
      setFilterValue("0");
    } else {
      setFilterValue(e);
    }
  };

  useEffect(() => {
    if (ischanged || !ischanged) {
      let spliType = filterValue.split(",");
      if (spliType.length > 1) {
      } else {
        settypeFlag(false);
      }

      if (calendarValue == 1) {
        setSelectedMonth(spliType);
        setSelectedQuarter(["0"]);
        setSelectedWeek(["0"]);
      } else if (calendarValue == 2) {
        setSelectedQuarter(spliType);
        setSelectedMonth(["0"]);
        setSelectedWeek(["0"]);
      } else {
        setSelectedWeek(spliType);
        setSelectedQuarter(["0"]);
        setSelectedMonth(["0"]);
      }
      const typeValue =
        calendarValue === 1
          ? "Month"
          : calendarValue === 2
          ? "Quarterly"
          : calendarValue === 3
          ? "Week"
          : calendarValue === 4
          ? "Day"
          : "Year";
      if (CountsOnLead) {
        dispatch(
          getCountOnLeadBarData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedStatus,
            value: "",
          })
        );
        dispatch(
          getCountOnLeadCardsData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedStatus,
            value: "",
          })
        );
      } else if (RingCentral) {
        dispatch(
          getRingCentralCardData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: "",
            value: "",
          })
        );
      } else if (csStatisfaction) {
        dispatch(
          getReviewData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedMatrix,
            value: "",
          })
        );
      } else if (sales) {
        dispatch(
          GetSalesData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedMatrix,
            value: metrics.metricesValue,
          })
        );
      } else if (RevenueModule) {
        dispatch(
          getRevenuData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedMatrix,
            value: metrics.metricesValue,
          })
        );
      } else if (Execution) {
        dispatch(
          GetExecutionData({
            type: typeValue,
            years: selectedYear,
            filter: filterValue,
            metrics: selectedMatrix,
            value: metrics.metricesValue,
          })
        );
      }

      dispatch(
        changeType({
          type: typeValue,
          filter: filterValue,
          metrices: selectedStatus === "" ? metrics.metrices : selectedStatus,
          metricesValue:
            selectedStatus === "" ? metrics.metricesValue : selectedStatus,
        })
      );
    }
  }, [filterValue]);

  const generateYearsArray = (startYear) => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];

    for (let year = startYear; year <= currentYear; year++) {
      yearsArray.push({ id: `${year}`, text: year });
    }

    return yearsArray;
  };

  useEffect(() => {
    let yearsArray = [];

    if (RingCentral) {
      yearsArray = generateYearsArray(2023);
    } else if (CountsOnLead) {
      yearsArray = generateYearsArray(2023);
    } else if (csStatisfaction) {
      yearsArray = generateYearsArray(2015);
    } else if (sales || RevenueModule || Execution) {
      yearsArray = generateYearsArray(2024);
    }

    setRevenueYear(yearsArray);
  }, [
    RingCentral,
    CountsOnLead,
    csStatisfaction,
    sales,
    RevenueModule,
    Execution,
  ]);

  useEffect(() => {
    if (calendarValue == 4) {
      if (ischanged) {
        dispatch(
          changeType({
            type:
              calendarValue === 1
                ? "Month"
                : calendarValue === 2
                ? "Quarterly"
                : calendarValue === 3
                ? "Week"
                : calendarValue === 4
                ? "Day"
                : "Year",
            filter: selectedDate,
            metrices: selectedStatus === "" ? metrics.metrices : selectedStatus,
            metricesValue:
              selectedStatus === "" ? metrics.metricesValue : selectedStatus,
          })
        );
        if (CountsOnLead) {
          dispatch(
            getCountOnLeadBarData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: selectedStatus,
              value: "",
            })
          );
          dispatch(
            getCountOnLeadCardsData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: selectedStatus,
              value: "",
            })
          );
        } else if (RingCentral) {
          dispatch(
            getRingCentralCardData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: "",
              value: "",
            })
          );
        } else if (csStatisfaction) {
          dispatch(
            getReviewData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: selectedMatrix,
              value: metrics.metricesValue,
            })
          );
        } else if (sales) {
          dispatch(
            GetSalesData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: selectedMatrix,
              value: metrics.metricesValue,
            })
          );
        } else if (RevenueModule) {
          dispatch(
            getRevenuData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: selectedMatrix,
              value: metrics.metricesValue,
            })
          );
        } else if (Execution) {
          dispatch(
            GetExecutionData({
              type:
                calendarValue === 1
                  ? "Month"
                  : calendarValue === 2
                  ? "Quarterly"
                  : calendarValue === 3
                  ? "Week"
                  : calendarValue === 4
                  ? "Day"
                  : "Year",
              years: selectedYear,
              filter: selectedDate,
              metrics: MetrixText,
              value: metrics.metricesValue,
            })
          );
        }
      }
    }
  }, [selectedDate]);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <form id="form-revenue">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-2 col-6">
                    <KendoDropdown
                      name="revenueYear"
                      data={revenueYear}
                      value={selectedYear}
                      dataTextField={"text"}
                      dataValueField={"id"}
                      onChange={revenueYearOnChage}
                    />
                  </div>

                  <div className="col-md-2 col-6">
                    <KendoDropdown
                      name="revenueCalendar"
                      data={revenueCalendar}
                      value={calendarValue}
                      dataTextField={"value"}
                      dataValueField={"id"}
                      onChange={(e) => {
                        if (e == 4) {
                          disableKendoDropdown("#revenueYear", false);
                        } else {
                          disableKendoDropdown("#revenueYear", true);
                        }
                        return revenueCalendarOnChange(e);
                      }}
                    />
                  </div>

                  {!isRevenueDay &&
                  (isRevenueMonth || isRevenueQuarter || isRevenueWeek) ? (
                    <div className="col-md-3 col-6">
                      <KendoMultiSelect
                        name="type"
                        data={
                          isRevenueMonth
                            ? months
                            : isRevenueQuarter
                            ? Quarterly
                            : isRevenueWeek
                            ? weeks
                            : []
                        }
                        value={
                          isRevenueMonth
                            ? selectedMonth
                            : isRevenueQuarter
                            ? selectedQuarter
                            : isRevenueWeek
                            ? selectedWeek
                            : undefined
                        }
                        dataTextField={"text"}
                        dataValueField={"id"}
                        onChange={(e) =>
                          typeOnChange(
                            e,
                            isRevenueMonth
                              ? "Month"
                              : isRevenueQuarter
                              ? "Quarterly"
                              : isRevenueWeek
                              ? "Week"
                              : isRevenueDay
                              ? "Day"
                              : ""
                          )
                        }
                        refreshWhen={typeFlag}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {isRevenueDay && (
                    <div className="col-md-3 col-6">
                      <KendoDatePicker
                        name={"date"}
                        value={selectedDate}
                        onChange={(e) => {
                          const date = new Date(e);

                          const formattedDate = date
                            .toLocaleDateString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })
                            .replace(/\//g, "-");
                          setSelectedDate(formattedDate);
                        }}
                      />
                    </div>
                  )}

                  {CountsOnLead && (
                    <div className="col-md-2 col-6">
                      <KendoMultiSelect
                        name="CountsOnLeadsMetric"
                        data={CountsOnLeadsFilters}
                        value={CountsOnLeadsMetrics}
                        dataTextField={"value"}
                        dataValueField={"id"}
                        onChange={(e) => LeadsMetricsOnChange(e)}
                        tagmode={
                          CountsOnLeadsMetricFlag ? "single" : "multiple"
                        }
                        refreshWhen={CountsOnLeadsMetricFlag}
                      />
                    </div>
                  )}

                  {CountsOnLead || RingCentral ? (
                    <></>
                  ) : (
                    <>
                      <div className="col-md-2 col-6">
                        <KendoDropdown
                          name="matrix"
                          data={Matrix}
                          value={MatrixValue}
                          dataTextField={"matrixValue"}
                          dataValueField={"matrixId"}
                          onChange={(e) => {
                            matrixOnChange(e);
                          }}
                        />
                      </div>

                      <div className="col-md-3 col-6">
                        <RevenueMatrix
                          calendarValue={
                            calendarValue === 1
                              ? "Month"
                              : calendarValue === 2
                              ? "Quarterly"
                              : calendarValue === 3
                              ? "Week"
                              : calendarValue === 4
                              ? "Day"
                              : "Year"
                          }
                          matrixValue={selectedMatrix}
                          selectedYear={selectedYear}
                          filter={
                            calendarValue === 0
                              ? "0"
                              : calendarValue === 1
                              ? selectedMonth
                              : calendarValue === 2
                              ? selectedQuarter
                              : calendarValue === 3
                              ? selectedWeek
                              : selectedDate
                          }
                          csStatisfaction={csStatisfaction}
                          sales={sales}
                          data={data}
                          revenue={RevenueModule}
                          Execution={Execution}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CommonDropdown;
